module.exports = __webpack_public_path__ + "static/media/intro.852bc3ae.mp3";